export default __webpack_public_path__ + "static/media/NftStore.42486010.gif";